import { AfterViewInit, Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';

declare var window: any;


export class TagifyComponent implements AfterViewInit {
	 public change = new EventEmitter<string[]>();
	 private tagifyElmElmRef: ElementRef;

	private tagify: any = null;

	public ngAfterViewInit() {
		this.loadTagifyScript();
	}

	public addTags(emails: string[]) {
		if (!this.tagify) {
			return;
		}

		this.tagify.removeAllTags();
		this.tagify.addTags(emails);
	}

	private onChange() {
		this.change.emit(this.tagify.value.map((item: any) => item.value));
	}

	private loadTagifyScript() {
		const tagifyId = 'hj-tagify';
		if (document.getElementById(tagifyId) as HTMLScriptElement) {
			this.initTagify();
			return;
		}

		const script: HTMLScriptElement = document.createElement('script');
		script.type = 'text/javascript';
		script.src = 'assets/vendor/tagify/tagify.min.js';
		script.id = tagifyId;
		script.addEventListener('load', () => this.initTagify());
		document.body.appendChild(script);
	}

	private initTagify() {
		if (!window.Tagify) {
			return;
		}
		this.tagify = new window.Tagify(this.tagifyElmElmRef.nativeElement, {
			delimiters: ',| |\n',
			pattern: /\S+@\S+\.\S+/,
			callbacks: {
				change: () => this.onChange()
			},
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/screen-talent/test/invite-candidate/tagify.component.ts